// initial state,
import { guest } from '../../plugin/axios'
export default{
  namespaced:true,
 state:{
    years: [],
    types:null,
    subTypes:null,
    year: null,
    loadYear: [],
    isLoading: false,
    isLoadingType: false,
    isLoadingSubType: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null,
},
 mutations:{
    setYears: (state, years) => {
        state.years = years
    },
    setLoadType: (state, types) => {
        state.types = types
    },
    setLoadSubType: (state, subTypes) => {
        state.subTypes = subTypes
    },
    setYearDetail: (state, year) => {
        state.year = year
    },
    saveNewYears: (state, year) => {
        // state.years.unshift(year)
        state.createdData = year
    },
    saveUpdatedYear: (state, year) => {
        // Find index
        // state.years.unshift(year)
        state.updatedData = year
        /*
        const index = state.years.findIndex(
            (year) => year.id === state.updatedData.id
        )
        if (index !== -1) {
            state.years.splice(index, 1, state.updatedData)
        }
        */
    },
    setDeleteYear: (state, id) => {
        const index = state.years
            .map((x) => {
                return x.id
            })
            .indexOf(id)
        state.years.splice(index, 1)
    },
    setYearIsLoading(state, isLoading) {
        state.isLoading = isLoading
    },
    setYearIsCreating(state, isCreating) {
        state.isCreating = isCreating
    },
    setYearIsUpdating(state, isUpdating) {
        state.isUpdating = isUpdating
    },
    setYearIsDeleting(state, isDeleting) {
        state.isDeleting = isDeleting
    },
    setLoadYear: (state, loadYear) => {
        state.loadYear = loadYear
    },
    setModelYearIsLoading(state, isLoading) {
        state.isLoading = isLoading
    },
    setTypeIsLoading(state, isLoadingType) {
        state.isLoadingType = isLoadingType
    },
    setSubTypeIsLoading(state, isLoadingSubType) {
        state.isLoadingType = isLoadingSubType
    },
},
 actions:{
    async fetchAllYears({ commit }) {
        commit('setYearIsLoading', true)
        await guest
            .get('/years')
            .then((res) => {
                const years = res.data.year
                commit('setYears', years)
                commit('setYearIsLoading', false)
            })
            .catch((err) => {
                this.$toast.error(err)
                commit('setYearIsLoading', false)
            })
    },
    async storeYear({ commit }, year) {
        commit('setYearIsCreating', true)
        await guest
            .post('/years-store', year)
            .then((res) => {
                if (res.data.email) {
                    this.$toast.error(res.data.email[0])
                    commit('setYearIsCreating', false)
                } else {
                    commit('saveNewYears', res.data.year)
                    commit('setYearIsCreating', false)
                }
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    commit('setYearIsCreating', false)
                    this.$toast.error('Field Not Properly Filled')
                }
            })
    },
    async fetchDetailYear({ commit }, id) {
        commit('setYearIsLoading', true)
        await guest
            .get(`years-show/${id}`)
            .then((res) => {
                commit('setYearDetail', res.data.year)
                commit('setYearIsLoading', false)
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    this.$toast.error('Field Not Properly Field')
                    commit('setYearIsLoading', false)
                }
            })
    },
    async updateYear({ commit }, year) {
        commit('setYearIsUpdating', true)
        await guest
            .post(`years-update/${year.id}`, year)
            .then((res) => {
                commit('saveUpdatedYear', res.data.year)
                commit('setYearIsUpdating', false)
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    this.$toast.error('Fields not properly filled')
                    commit('setYearIsUpdating', false)
                }
            })
    },
    async deleteYear({ commit }, id) {
        commit('setYearIsDeleting', true)
        await guest
            .delete(`years-delete/${id}`)
            .then((res) => {
                commit('setDeleteYear', res.data.year.id)
                commit('setYearIsDeleting', false)
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    this.$toast.error('Field Not Properly Filled')
                    commit('setYearIsDeleting', false)
                }
            })
    },
    async fetchLoadYear({ commit }, id) {
        commit('setYearIsLoading', true)
        await guest
            .get(`years-show/${id}`)
            .then((res) => {
                commit('setLoadYear', res.data.year)
                commit('setYearIsLoading', false)
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    this.$toast.error('Field Not Properly Field')
                    commit('setYearIsLoading', false)
                }
            })
    },

    fetchLoadType({ commit }, id) {
        commit('setTypeIsLoading', true)
        try{
            commit('setLoadType', ['Automatic','Manual','Others'])
            commit('setTypeIsLoading', false)
        }
        catch(e){
            commit('setTypeIsLoading', false)
        }
    },

    fetchLoadSubType({ commit }, id) {
        commit('setSubTypeIsLoading', true)
        try{
            if(id === 'Seller'){
                commit('setLoadSubType', ['Seller'])
                commit('setSubTypeIsLoading', false)
            }
            else{
                commit('setLoadSubType', ['UBER','Bolt','Corporate','PLENTY WAKA','Pam Drive'])
                commit('setSubTypeIsLoading', false)
            }
        }
        catch(e){
            commit('setTypeIsLoading', false)
        }
    },
},
 getters:{
    yearList: (state) => state.years,
    typeList: (state) => state.types,
    subTypeList: (state) => state.subTypes,
    year: (state) => state.year,
    isLoadingYear: (state) => state.isLoading,
    isTypeIsLoading:(state) =>state.isLoadingType,
    isCreating: (state) => state.isCreating,
    isUpdating: (state) => state.isUpdating,
    createdData: (state) => state.createdData,
    updatedData: (state) => state.updatedData,
    isDeleting: (state) => state.isDeleting,
    deletedData: (state) => state.deletedData,
    yearBaseOnModelList: (state) => state.loadYear,
}
}
